import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { purchaseStageSwitchAnimation, dialogRiseAnimation } from "../../../animations/pricing-animations";
import { InvoicePlanUpgradeComponent } from "../invoices/invoice-plan-upgrade/invoice-plan-upgrade.component";

@Component({
  selector: 'app-dialog-invoice-plan-upgrade',
  imports: [
    InvoicePlanUpgradeComponent
],
  templateUrl: './dialog-invoice-plan-upgrade.component.html',
  styleUrl: './dialog-invoice-plan-upgrade.component.scss',
  animations: [purchaseStageSwitchAnimation, dialogRiseAnimation]
})
export class DialogInvoicePlanUpgradeComponent {
  invoiceUuid: string = inject(MAT_DIALOG_DATA);

}
